<!-- eslint-disable -->
<template>
  <v-container
    fluid
    class="pa-2 pa-sm-8 min-h-screen bg-slate-50 d-flex flex-column align-center justify-center"
  >
    <SnackBar ref="snackbar" />

    <div v-if="loading" class="text-center py-16">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
        class="mb-4"
      ></v-progress-circular>
      <p class="text-slate-500 font-medium">
        Carregando formulário de validação...
      </p>
    </div>

    <v-card
      v-else
      class="w-full max-w-3xl rounded-2xl border border-slate-200 shadow-lg overflow-hidden bg-white"
    >
      <!-- HEADER -->
      <div class="bg-primary text-white pa-4 pa-sm-6 text-left">
        <div
          class="text-xs uppercase font-black tracking-wider text-slate-200 mb-1"
        >
          Formulário de Validação
        </div>
        <h1 class="text-2xl font-black onest-font leading-tight">
          {{ funcionalidade.titulo || 'Avaliar Funcionalidade' }}
        </h1>
        <p class="text-sm text-slate-100 mt-2">
          {{
            funcionalidade.objetivo ||
            'Responda as questões abaixo com base nos testes executados.'
          }}
        </p>
      </div>

      <!-- INACTIVE WARNING -->
      <div
        v-if="!isCycleActive"
        class="bg-amber-50 border-b border-amber-150 pa-4 d-flex align-center"
      >
        <v-icon color="warning" class="mr-3" size="24">mdi-lock-outline</v-icon>
        <div class="text-sm text-amber-900 font-medium">
          <strong>Modo de Leitura:</strong> Esta validação está encerrada. As
          respostas salvas abaixo não podem ser modificadas.
        </div>
      </div>

      <div class="mb-6 bg-white rounded-xl border border-slate-200 pa-4 pa-sm-6 shadow-sm text-slate-700">
        <div class="mb-4 text-justify text-sm sm:text-base leading-relaxed">
          Este formulário tem como objetivo obter a sua percepção sobre a
          funcionalidade <b>{{ nomeDaFuncionalidade || 'selecionada' }}</b> uma das principais
          funcionalidades do projeto <b>{{ nomeDoProjeto || 'atual' }}</b>. O formulário
          deve ser preenchido após sua experiência utilizando esta
          funcionalidade, com um usuário de testes com o perfil de
          <b>{{ atorDaFuncionalidade || 'testador' }}</b>.
        </div>

        <div v-if="descricaoTcle" class="mb-4 text-justify text-sm sm:text-base leading-relaxed">
          {{ descricaoTcle }}
        </div>
        <div v-if="explicacaoAvaliacao" class="text-justify text-sm sm:text-base leading-relaxed">
          {{ explicacaoAvaliacao }}
        </div>
      </div>

      <!-- FORM CONTENT -->
      <v-card-text class="pa-4 pa-sm-8 bg-slate-50/20">
        <v-form ref="form" v-model="formValid" lazy-validation>
          <!-- OBJECTIVE CRITERIA -->
          <div v-if="questoesObjetivas.length > 0" class="mb-8">
            <h3
              class="text-lg font-black text-slate-800 border-b border-slate-150 pb-2 mb-4 d-flex align-center"
            >
              <v-icon color="primary" class="mr-2" size="20"
                >mdi-sticker-check-outline</v-icon
              >
              Critérios Objetivos
            </h3>

            <div
              v-for="criterio in questoesObjetivas"
              :key="criterio.id"
              class="mb-6 bg-white rounded-xl border border-slate-200 pa-4 pa-sm-5 shadow-sm"
            >
              <h4 class="font-bold text-slate-700 text-sm sm:text-base mb-3">
                {{ criterio.pergunta }}
              </h4>

              <v-radio-group
                v-model="respostasObjetivas[criterio.id]"
                :disabled="!isCycleActive"
                :rules="[(v) => !!v || 'Este campo é obrigatório']"
                color="primary"
                hide-details="auto"
                class="mt-2 [&_.v-selection-control-group]:flex [&_.v-selection-control-group]:flex-col sm:[&_.v-selection-control-group]:flex-row sm:[&_.v-selection-control-group]:flex-nowrap sm:[&_.v-selection-control-group]:justify-between"
              >
                <v-radio
                  v-for="opcao in criterio.opcoes"
                  :key="opcao.id"
                  :label="opcao.texto"
                  :value="opcao.id"
                  class="mb-2 font-medium"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>

          <!-- SUBJECTIVE FEEDBACK -->
          <div v-if="questoesSubjetivas.length > 0" class="mb-6">
            <h3
              class="text-lg font-black text-slate-800 border-b border-slate-150 pb-2 mb-4 d-flex align-center"
            >
              <v-icon color="primary" class="mr-2" size="20"
                >mdi-comment-text-outline</v-icon
              >
              Comentários / Feedback
            </h3>

            <div
              v-for="criterio in questoesSubjetivas"
              :key="criterio.id"
              class="mb-6 bg-white rounded-xl border border-slate-200 pa-4 pa-sm-5 shadow-sm"
            >
              <h4 class="font-bold text-slate-700 text-sm sm:text-base mb-3">
                {{ criterio.pergunta }}
              </h4>

              <v-textarea
                v-model="respostasSubjetivas[criterio.id]"
                :disabled="!isCycleActive"
                variant="outlined"
                rows="4"
                no-resize
                color="primary"
                class="bg-slate-50/50 rounded-xl"
                placeholder="Escreva suas observações detalhadas aqui..."
                hide-details="auto"
              ></v-textarea>
            </div>
          </div>

          <!-- BUG ATTACHMENTS (OPTIONAL) -->
          <div v-if="isCycleActive" class="mb-6">
            <h3
              class="text-lg font-black text-slate-800 border-b border-slate-150 pb-2 mb-4 d-flex align-center"
            >
              <v-icon color="warning" class="mr-2" size="20"
                >mdi-paperclip</v-icon
              >
              Evidências de Bug — Opcional (Fotos / Vídeos)
            </h3>

            <div
              class="bg-white rounded-xl border border-slate-200 pa-4 pa-sm-5 shadow-sm"
            >
              <p class="text-sm text-slate-500 mb-4">
                Se encontrou algum bug durante o teste, anexe fotos ou vídeos
                como evidência. A descrição deve ser feita nas perguntas acima.
              </p>

              <!-- Drop zone -->
              <div
                class="border-2 border-dashed border-slate-300 rounded-xl pa-6 text-center cursor-pointer transition-colors"
                :class="{ 'border-primary bg-blue-50': arquivosBug.length > 0 }"
                @click="$refs.fileInputBug.click()"
              >
                <input
                  type="file"
                  ref="fileInputBug"
                  multiple
                  accept="image/*,video/*"
                  class="d-none"
                  @change="onBugFilesSelected"
                />
                <v-icon size="36" color="slate-400" class="mb-2"
                  >mdi-cloud-upload-outline</v-icon
                >
                <p class="text-sm text-slate-500 mb-1">
                  Clique para selecionar fotos ou vídeos
                </p>
                <p class="text-xs text-slate-400">JPG, PNG, MP4, MOV</p>
              </div>

              <!-- Arquivos já enviados -->
              <div v-if="arquivosSalvos.length > 0" class="mb-4">
                <p class="text-sm font-weight-bold text-slate-700 mb-2">
                  Evidências já enviadas:
                </p>
                <div class="d-flex flex-wrap gap-2">
                  <v-chip
                    v-for="anexo in arquivosSalvos"
                    :key="anexo.id_arquivo"
                    size="small"
                    color="success"
                    variant="tonal"
                    :prepend-icon="
                      anexo.tipo_arquivo === 'VIDEO' ? 'mdi-video' : 'mdi-image'
                    "
                    :href="anexo.localizacao"
                    target="_blank"
                  >
                    {{
                      anexo.nome.length > 24
                        ? anexo.nome.substring(0, 24) + '...'
                        : anexo.nome
                    }}
                    <v-icon end size="small">mdi-open-in-new</v-icon>
                  </v-chip>
                </div>
              </div>

              <!-- File chips (novos arquivos) -->
              <div
                v-if="arquivosBug.length > 0"
                class="mt-3 d-flex flex-wrap gap-2"
              >
                <v-chip
                  v-for="(file, idx) in arquivosBug"
                  :key="idx"
                  size="small"
                  color="primary"
                  variant="tonal"
                  :prepend-icon="
                    file.type.startsWith('video/') ? 'mdi-video' : 'mdi-image'
                  "
                  closable
                  @click:close="removeBugFile(idx)"
                >
                  {{
                    file.name.length > 24
                      ? file.name.substring(0, 24) + '...'
                      : file.name
                  }}
                </v-chip>
              </div>

              <!-- Upload progress -->
              <div v-if="uploadingBug" class="mt-3 d-flex align-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="20"
                  class="mr-2"
                ></v-progress-circular>
                <span class="text-sm text-slate-500">Enviando arquivos...</span>
              </div>
              <div v-if="uploadBugDone" class="mt-3 d-flex align-center">
                <v-icon color="success" class="mr-2" size="20"
                  >mdi-check-circle</v-icon
                >
                <span class="text-sm text-green-700 font-medium"
                  >Arquivos enviados com sucesso!</span
                >
              </div>
            </div>
          </div>

          <div
            v-if="
              questoesObjetivas.length === 0 && questoesSubjetivas.length === 0
            "
            class="text-center py-8"
          >
            <v-icon size="48" color="slate-300"
              >mdi-clipboard-alert-outline</v-icon
            >
            <p class="text-slate-500 mt-2">
              Nenhuma pergunta definida para este formulário de validação.
            </p>
          </div>
        </v-form>
      </v-card-text>

      <!-- FOOTER ACTIONS -->
      <v-divider></v-divider>
      <v-card-actions
        class="pa-4 pa-sm-6 justify-end gap-2 bg-white flex-nowrap"
      >
        <v-btn
          variant="outlined"
          color="slate-500"
          rounded="lg"
          size="large"
          class="font-bold text-none px-6"
          @click="goBack"
        >
          {{ isCycleActive ? 'Cancelar' : 'Voltar' }}
        </v-btn>

        <v-btn
          v-if="isCycleActive"
          color="success"
          variant="flat"
          rounded="lg"
          size="large"
          class="font-black text-none px-8 shadow-md"
          prepend-icon="mdi-content-save-outline"
          @click="salvarFormulario"
        >
          Salvar Resposta
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import SnackBar from '@/components/SnackBar.vue';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  name: 'FormularioExecucaoTestador',
  components: {
    SnackBar,
  },
  data() {
    return {
      idRoteiro: null,
      idProjeto: null,
      idEscopoTeste: null,
      idUsuario: Number(localStorage.getItem('idUsuario')) || 1,
      loading: false,
      isCycleActive: true,
      formValid: true,
      funcionalidade: { titulo: '', objetivo: '' },
      descricaoTcle: '',
      explicacaoAvaliacao: '',
      nomeDaFuncionalidade: '',
      nomeDoProjeto: '',
      atorDaFuncionalidade: '',
      respostasObjetivas: {},
      respostasSubjetivas: {},
      questoesObjetivas: [],
      questoesSubjetivas: [],
      arquivosBug: [],
      arquivosSalvos: [],
      uploadingBug: false,
      uploadBugDone: false,
    };
  },
  created() {
    this.idRoteiro = Number(this.$route.params.idRoteiro);
    this.idProjeto = Number(this.$route.params.idProjeto);
    this.idEscopoTeste = Number(this.$route.params.idEscopoTeste);
    this.carregarFormulario();
  },
  methods: {
    goBack() {
      this.$router.push(
        `/projects/${this.idProjeto}/roteiros/${this.idRoteiro}/executar`,
      );
    },
    async carregarFormulario() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/usuario-externo/roteiros/${this.idRoteiro}/escopos/${this.idEscopoTeste}/formulario`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          },
        );
        const data = response.data;
        this.funcionalidade.titulo = data.titulo || 'Formulário de Validação';
        this.descricaoTcle = data.descricaoTcle || '';
        this.explicacaoAvaliacao = data.explicacaoAvaliacao || '';
        this.nomeDaFuncionalidade = data.nomeDaFuncionalidade || '';
        this.nomeDoProjeto = data.nomeDoProjeto || '';
        this.atorDaFuncionalidade = data.atorDaFuncionalidade || '';
        this.questoesObjetivas = data.questoesObjetivas || [];
        this.questoesSubjetivas = data.questoesSubjetivas || [];
        this.arquivosSalvos = data.arquivosSalvos || [];

        const objResp = {};
        for (const c of this.questoesObjetivas) {
          objResp[c.id] = data.respostasObjetivas?.[c.id] || null;
        }
        this.respostasObjetivas = objResp;

        const subjResp = {};
        for (const s of this.questoesSubjetivas) {
          subjResp[s.id] = data.respostasSubjetivas?.[s.id] || '';
        }
        this.respostasSubjetivas = subjResp;
      } catch (error) {
        const errMsg =
          error.response?.data?.detalhes ||
          error.response?.data?.error ||
          error.message;
        console.error('Erro ao carregar formulário do backend:', errMsg, error);

        // Fallback title
        const funcInfo = this.mockFuncTitles[this.idEscopoTeste];
        if (funcInfo) {
          this.funcionalidade = funcInfo;
        }

        this.questoesObjetivas = [
          {
            id: 1,
            pergunta:
              'A funcionalidade atende ao objetivo descrito no roteiro de testes?',
            opcoes: [
              { id: 10, texto: 'Sim, atende completamente' },
              { id: 5, texto: 'Parcialmente (existem pequenas pendências)' },
              {
                id: 0,
                texto: 'Não atende (falha crítica ou não implementado)',
              },
            ],
          },
          {
            id: 2,
            pergunta:
              'Foi fácil localizar e executar as ações necessárias no sistema?',
            opcoes: [
              { id: 11, texto: 'Muito intuitivo e fácil' },
              { id: 6, texto: 'Razoável, mas exige alguma explicação' },
              { id: 1, texto: 'Muito complexo ou confuso' },
            ],
          },
        ];
        this.questoesSubjetivas = [
          {
            id: 4,
            pergunta:
              'Descreva qualquer dificuldade ou comportamento inesperado observado durante a execução.',
          },
        ];

        // Load previous answers from localStorage
        const savedAnswers = localStorage.getItem(
          `feedback_user_${this.idUsuario}_roteiro_${this.idRoteiro}_escopo_${this.idEscopoTeste}`,
        );
        let localObj = {};
        let localSubj = {};
        if (savedAnswers) {
          try {
            const parsed = JSON.parse(savedAnswers);
            localObj = parsed.respostasObjetivas || {};
            localSubj = parsed.respostasSubjetivas || {};
          } catch (e) {
            console.error('Error parsing saved answers:', e);
          }
        }

        const objResp = {};
        for (const c of this.questoesObjetivas) {
          objResp[c.id] = localObj[c.id] || null;
        }
        this.respostasObjetivas = objResp;

        const subjResp = {};
        for (const s of this.questoesSubjetivas) {
          subjResp[s.id] = localSubj[s.id] || '';
        }
        this.respostasSubjetivas = subjResp;
      } finally {
        this.loading = false;
      }
    },
    async salvarFormulario() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$refs.snackbar.showErrorSnackbar(
          'Atenção',
          'Por favor, responda todas as questões objetivas antes de salvar.',
        );
        return;
      }

      this.loading = true;
      try {
        await axios.post(
          `${apiUrl}/api/v1/usuario-externo/roteiros/${this.idRoteiro}/escopos/${this.idEscopoTeste}/formulario`,
          {
            respostasObjetivas: this.respostasObjetivas,
            respostasSubjetivas: this.respostasSubjetivas,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          },
        );

        // Upload bug evidence files if any
        if (this.arquivosBug.length > 0) {
          this.uploadingBug = true;
          try {
            const formData = new FormData();
            const desc =
              Object.values(this.respostasSubjetivas)
                .filter((v) => typeof v === 'string' && v.trim())
                .join(' | ') || 'Bug com arquivos anexados pelo testador';
            formData.append('descricaoBug', desc);
            formData.append('id_usuario_testador', this.idUsuarioTestador);
            for (const file of this.arquivosBug) {
              formData.append('arquivos', file);
            }
            await axios.post(
              `${apiUrl}/api/v1/usuario-externo/roteiros/${this.idRoteiro}/escopos/${this.idEscopoTeste}/bug-arquivo`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  'Content-Type': 'multipart/form-data',
                },
              },
            );
            this.uploadBugDone = true;
          } catch (uploadErr) {
            console.error('Erro ao fazer upload de evidências:', uploadErr);
          } finally {
            this.uploadingBug = false;
          }
        }

        // Mirror in localStorage for instant local progress checks
        const payload = {
          respostasObjetivas: this.respostasObjetivas,
          respostasSubjetivas: this.respostasSubjetivas,
          savedAt: new Date().toISOString(),
        };
        localStorage.setItem(
          `feedback_user_${this.idUsuario}_roteiro_${this.idRoteiro}_escopo_${this.idEscopoTeste}`,
          JSON.stringify(payload),
        );

        this.$router.push({
          path: `/projects/${this.idProjeto}/roteiros/${this.idRoteiro}/executar`,
          query: { saveStatus: 'success' }
        });
      } catch (error) {
        console.error('Erro ao salvar formulário no backend:', error);
        const errMsg =
          error.response?.data?.detalhes ||
          error.response?.data?.error ||
          error.message;
          
        this.$router.push({
          path: `/projects/${this.idProjeto}/roteiros/${this.idRoteiro}/executar`,
          query: { saveStatus: 'error', errorMsg: errMsg }
        });
      } finally {
        this.loading = false;
      }
    },
    onBugFilesSelected(event) {
      const files = Array.from(event.target.files);
      this.arquivosBug = [...this.arquivosBug, ...files];
    },
    removeBugFile(index) {
      this.arquivosBug.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}
.bg-slate-50 {
  background-color: #f8fafc !important;
}
.bg-amber-50 {
  background-color: #fffbeb !important;
}
.border-amber-150 {
  border-color: #fef3c7 !important;
}
.text-amber-900 {
  color: #78350f !important;
}
@media (max-width: 599.98px) {
  .w-full {
    width: 100% !important;
  }
}
</style>
